import { Component, Inject, OnInit } from '@angular/core';
import IIsNotCalibratedReason = ZoneIQCalibration.IIsNotCalibratedReason;
import { CommonService } from 'src/shared/services/common.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as _ from 'lodash';
import { IsNotCalibratedReasonService } from 'src/app/core/services/is-not-calibrated-reason.service';

export interface IINCREditData {
    record: IIsNotCalibratedReason;
    existingRecords: IIsNotCalibratedReason[];
}

@Component({
    standalone: false,
    selector: 'app-incr-edit-popup',
    templateUrl: './incr-edit-popup.component.html',
    styleUrls: ['./incr-edit-popup.component.scss']

})
export class IncrEditPopupComponent implements OnInit {
    isValidRecord = false;
    validationErrors = '';
    originalRecord: IIsNotCalibratedReason;
    currentRecord: IIsNotCalibratedReason;
    isExecuting: boolean = false;

    get isExistingUseLabel() {
        return !!_.get(this, 'data.record.Id');
    }

    constructor(
        private commonService: CommonService,
        public dialogRef: MatDialogRef<IncrEditPopupComponent>,
        @Inject(MAT_DIALOG_DATA) public data: IINCREditData,
        private isNotCalibratedReasonService: IsNotCalibratedReasonService
    ) {}

    ngOnInit() {
        this.originalRecord = this.data.record || this.getDefaultRecord();
        this.currentRecord = _.cloneDeep(this.originalRecord);
        this.checkValidation(this.currentRecord.Reason);
    }

    checkValidation(value: string) {
        this.isValidRecord = true;
        this.validationErrors = '';

        if (!this.commonService.checkEmptyString(value)) {
            this.isValidRecord = false;
            this.validationErrors = 'Reason label can not be empty';
            return;
        }
        const trimmedValue = value.trim();
        if (
            this.data.existingRecords.find(
                record =>
                    record.Reason === trimmedValue &&
                    (!this.currentRecord.Id || (this.currentRecord.Id && record.Id !== this.currentRecord.Id))
            )
        ) {
            this.isValidRecord = false;
            this.validationErrors = 'Reason with current label already exists';
            return;
        }
    }

    updateRecord() {
        if (!this.isValidRecord) {
            return;
        }
        this.isExecuting = true;
        const method = this.currentRecord.Id
            ? this.isNotCalibratedReasonService.updatedIsNotCalibratedReason(this.currentRecord)
            : this.isNotCalibratedReasonService.createIsNotCalibratedReason(this.currentRecord);
        method.subscribe(reason => {
            if (reason) {
                this.dialogRef.close();
                return;
            }
            this.isValidRecord = false;
            this.validationErrors = this.currentRecord.Id ? 'Error when updating Reason' : 'Error when creating Reason';
            this.isExecuting = false;
        });
    }

    getDefaultRecord(): IIsNotCalibratedReason {
        const nextOrder = this.data.existingRecords.length + 1;
        return {
            Reason: '',
            IsDefault: false,
            Order: nextOrder
        };
    }
}
